/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Crm_Expects_LiveInputs */

const cs_portals_crm_expects_live = /** @type {(inputs: Portals_Crm_Expects_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const en_portals_crm_expects_live = /** @type {(inputs: Portals_Crm_Expects_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Portals_Crm_Expects_LiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_crm_expects_live = /** @type {((inputs?: Portals_Crm_Expects_LiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Crm_Expects_LiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_crm_expects_live(inputs)
	return cs_portals_crm_expects_live(inputs)
});